import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { text } from 'style/mixin';
import { mq } from 'style/variables';
import fonts from 'style/fonts';

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  ${mq.onlysp} {
    gap: 9px;
  }
`;

const H2HeadingEn = styled.h2`
  ${text(32, 1.04, true)}
  white-space: pre-line;
  letter-spacing: 0;

  ${mq.onlysp} {
    ${text(24, 1, true)}
  }
`;

const HeadingJa = styled.span`
  font-family: ${fonts.jaGothic};
  ${text(20, 1.2, true)}
  padding: 0 2px;
  font-weight: 600;

  ${mq.onlysp} {
    ${text(17, 1.2, true)}
    font-weight: 600;
    margin-left: 0;
    margin-top: 0;
  }
`;

export const CareerDetailHeading = ({ titleEn, titleJa }: { titleEn: string; titleJa: string }) => {
  const lines = useMemo(() => titleEn.split('\\n'), [titleEn]);

  return (
    <HeadingWrapper>
      <H2HeadingEn>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
            {line}
            {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </H2HeadingEn>
      <HeadingJa>{titleJa}</HeadingJa>
    </HeadingWrapper>
  );
};
